import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcClose24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m5 18c0-.281.094-.5.281-.688l5.313-5.312-5.314-5.313a1.03 1.03 0 0 1 -.249-.687c0-.563.438-.969.969-.969.281 0 .5.094.688.25l5.312 5.313 5.313-5.313a.92.92 0 0 1 .687-.281c.563 0 1 .438 1 1 0 .281-.094.5-.313.688l-5.28 5.312 5.28 5.313a.844.844 0 0 1 .313.687.98.98 0 0 1 -.969 1 .915.915 0 0 1 -.718-.313l-5.313-5.28-5.313 5.28a.915.915 0 0 1 -.717.313.98.98 0 0 1 -.97-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcClose24;
